<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card v-for="(category, i) in categories" :key="'category-' + i" style="cursor:pointer;">
          <v-card-text class="py-0 mb-3">
            <v-row class="pa-0 align-center">
              <v-col cols="3">
                <div>
                  <span class="label">Name</span>
                  <div class="mt-1">{{ category.name }}</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div>
                  <span class="label">Grand category</span>
                  <div class="mt-1">{{ category.gama_grand_category ? category.gama_grand_category.name : 'N/A' }}</div>
                </div>
              </v-col>
              <v-col cols="2">
                <div>
                  <span class="label">Leads count</span>
                  <div class="mt-1">{{ category.leads_count }}</div>
                </div>
              </v-col>
              <v-col cols="2">
                <div>
                  <span class="label">Created at</span>
                  <div>
                    <v-chip color="primary" small class="mt-1">{{ getFormat(category.created_at) }}</v-chip>
                  </div>
                </div>
              </v-col>
              <v-col cols="2">
                <div>
                  <v-btn small color="primary" @click.prevent="edit(category)">
                    <v-icon small>edit</v-icon>
                    <span>Edit</span>
                  </v-btn>
                  <v-btn small color="error" class="ml-2" @click.prevent="() => _delete(category)">
                    <v-icon small>delete</v-icon>
                    <span>Delete</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from 'timeago.js';

export default {
  props: ['categories'],
  methods: {
    getFormat(d) {
      return format(d)
    },
    edit(category) {
      this.$emit('editResource', category)
    },
    _delete(category) {
      this.$emit('triggerDeleteResource', category)
    },
  }
}
</script>

<style scoped>

.label {
  font-size: 12px;
  font-weight: 600;
}

</style>